"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDisableOrganizationMutation = exports.useEnableOrganizationMutation = exports.useDeleteOrganizationMutation = exports.useUpdateOrganizationMutation = exports.useCreateOrganizationMutation = exports.useGetOrganizationProductsQuery = exports.useGetOrganizationCustomersQuery = exports.useGetOrganizationQuery = exports.useLazyGetOrganizationsQuery = exports.useGetOrganizationsQuery = exports.organizationsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.organizationsApi = (0, react_1.createApi)({
    reducerPath: "organizationsApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Organizations"],
    endpoints: function (builder) { return ({
        getOrganizations: builder.query({
            query: function (params) { return ({
                url: "/v1/organizations",
                params: params,
            }); },
            providesTags: function (result) {
                var _a;
                var organizations = ((_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.organizations) || [];
                return organizations.length > 0
                    ? __spreadArray(__spreadArray([], organizations.map(function (_a) {
                        var _id = _a._id;
                        return ({
                            type: "Organizations",
                            id: _id,
                        });
                    }), true), [
                        { type: "Organizations", id: "LIST" },
                    ], false) : [{ type: "Organizations", id: "LIST" }];
            },
        }),
        getOrganization: builder.query({
            query: function (id) { return "/v1/organizations/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "Organizations", id: id }]; },
        }),
        getOrganizationCustomers: builder.query({
            query: function (_a) {
                var id = _a.id, params = __rest(_a, ["id"]);
                return ({
                    url: "/v1/organizations/".concat(id, "/customers"),
                    params: params,
                });
            },
        }),
        getOrganizationProducts: builder.query({
            query: function (id) { return "/v1/organizations/".concat(id, "/products"); },
        }),
        createOrganization: builder.mutation({
            query: function (data) { return ({
                url: "/v1/organizations",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: [{ type: "Organizations", id: "LIST" }],
        }),
        updateOrganization: builder.mutation({
            query: function (_a) {
                var id = _a.id, data = _a.data;
                return ({
                    url: "/v1/organizations/".concat(id),
                    method: "PATCH",
                    body: data,
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Organizations", id: id },
                    { type: "Organizations", id: "LIST" },
                ];
            },
        }),
        deleteOrganization: builder.mutation({
            query: function (id) { return ({
                url: "/v1/organizations/".concat(id),
                method: "DELETE",
            }); },
            invalidatesTags: [{ type: "Organizations", id: "LIST" }],
        }),
        enableOrganization: builder.mutation({
            query: function (id) { return ({
                url: "/v1/organizations/".concat(id, "/enable"),
                method: "POST",
            }); },
            invalidatesTags: function (result, error, id) { return [
                { type: "Organizations", id: id },
                { type: "Organizations", id: "LIST" },
            ]; },
        }),
        disableOrganization: builder.mutation({
            query: function (id) { return ({
                url: "/v1/organizations/".concat(id, "/disable"),
                method: "POST",
            }); },
            invalidatesTags: function (result, error, id) { return [
                { type: "Organizations", id: id },
                { type: "Organizations", id: "LIST" },
            ]; },
        }),
    }); },
});
exports.useGetOrganizationsQuery = exports.organizationsApi.useGetOrganizationsQuery, exports.useLazyGetOrganizationsQuery = exports.organizationsApi.useLazyGetOrganizationsQuery, exports.useGetOrganizationQuery = exports.organizationsApi.useGetOrganizationQuery, exports.useGetOrganizationCustomersQuery = exports.organizationsApi.useGetOrganizationCustomersQuery, exports.useGetOrganizationProductsQuery = exports.organizationsApi.useGetOrganizationProductsQuery, exports.useCreateOrganizationMutation = exports.organizationsApi.useCreateOrganizationMutation, exports.useUpdateOrganizationMutation = exports.organizationsApi.useUpdateOrganizationMutation, exports.useDeleteOrganizationMutation = exports.organizationsApi.useDeleteOrganizationMutation, exports.useEnableOrganizationMutation = exports.organizationsApi.useEnableOrganizationMutation, exports.useDisableOrganizationMutation = exports.organizationsApi.useDisableOrganizationMutation;
